export const MAX_BRAND_COLORS = 5;

const HEX_6 = /^#?([0-9a-f]{6})$/i;
const HEX_3 = /^#?([0-9a-f]{3})$/i;
const RGB_FN = /^rgb\s*\(\s*(.+?)\s*\)$/i;
const RGB_SEPARATOR = /\s*,\s*|\s+/;

function toHexByte(n: number): string {
	return n.toString(16).padStart(2, "0").toUpperCase();
}

function parseRgbChannels(body: string): string | null {
	const parts = body.trim().split(RGB_SEPARATOR);
	if (parts.length !== 3) return null;

	const channels: number[] = [];
	for (const part of parts) {
		if (!/^\d{1,3}$/.test(part)) return null;
		const n = Number(part);
		if (n < 0 || n > 255) return null;
		channels.push(n);
	}

	return `#${channels.map(toHexByte).join("")}`;
}

/**
 * Normalises user-entered colour text into an uppercase `#RRGGBB` hex string.
 *
 * Accepts `#RRGGBB`, `RRGGBB`, `#RGB`, `RGB`, `rgb(r, g, b)`, `rgb(r g b)`,
 * `r, g, b` and `r g b`. Returns `null` for anything else.
 */
export function parseBrandColor(input: string): string | null {
	const value = input.trim();
	if (value === "") return null;

	const hex6 = HEX_6.exec(value);
	if (hex6) return `#${hex6[1].toUpperCase()}`;

	const hex3 = HEX_3.exec(value);
	if (hex3) {
		const digits = hex3[1].toUpperCase();
		return `#${digits[0]}${digits[0]}${digits[1]}${digits[1]}${digits[2]}${digits[2]}`;
	}

	const rgbFn = RGB_FN.exec(value);
	if (rgbFn) return parseRgbChannels(rgbFn[1]);

	return parseRgbChannels(value);
}
